/**
 * Generic status history stage — structure-scoped, nested in the site dashboard.
 *
 * Rendered as a child route of SiteDashboardLayout, inside the shared
 * dashboard shell (which supplies AppNav + TitleBar). Splits the relay
 * controller's generic status log into a master grid and a side detail panel.
 *
 * Contains:
 * - GenericStatusView — route child component (default export)
 */
import { Box, Grid } from '@mui/material';
import React, { useState } from 'react';

import LoadingScreen from '@sophocles/components/LoadingScreen';
import GenericStatusDetail from '@sophocles/views/sites/components/GenericStatusDetail';
import GenericStatusGrid from '@sophocles/views/sites/components/GenericStatusGrid';
import { useSiteDashboardLayoutContext } from '@sophocles/views/sites/SiteDashboardLayout';

function GenericStatusView() {
  const { unit, site, loading } = useSiteDashboardLayoutContext();
  const [selectedItem, setSelectedItem] = useState(null);

  if (loading) {
    return <LoadingScreen />;
  }

  const relayControllerId = unit?.id ?? null;
  const timeZone = site?.time_zone ?? 'UTC';

  return (
    <Box sx={{ pb: 2, flex: 1, minHeight: 0 }}>
      <Grid container spacing={1.5} sx={{ height: '100%' }}>
        <Grid size={4}>
          <GenericStatusGrid
            relayControllerId={relayControllerId}
            onSelectedChange={selected => {
              setSelectedItem(selected);
            }}
          />
        </Grid>
        <Grid size={8}>
          <GenericStatusDetail selectedItem={selectedItem} unitTimeZone={timeZone} />
        </Grid>
      </Grid>
    </Box>
  );
}

export default GenericStatusView;
